export default function Success() {
  return (
    <div className="min-h-screen flex items-center justify-center text-center">
      <h1 className="text-3xl font-bold text-green-600">
        ✅ Payment Successful
      </h1>
      <p className="mt-4 text-gray-600">Thanks for your order! Your confirmation will be sent shortly.</p>
    </div>
  )
}